module.exports = __webpack_public_path__ + "static/confetti_bricks-f71b0e8f6e588889e96a3a4136c05974.png";